import { IndicatorsContainer, SelectContainer, ValueContainer } from "./containers";
import Control, { ClearIndicator, DropdownIndicator, IndicatorSeparator, LoadingIndicator } from "./control";
import Input from "./input";
import Menu, { Group, GroupHeading, LoadingMessage, MenuList, NoOptionsMessage, Option } from "./menu";
import MultiValue, { MultiValueContainer, MultiValueLabel, MultiValueRemove } from "./multi-value";
import Placeholder from "./placeholder";
import SingleValue from "./single-value";
var chakraComponents = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorSeparator: IndicatorSeparator,
  IndicatorsContainer: IndicatorsContainer,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  LoadingMessage: LoadingMessage,
  Menu: Menu,
  MenuList: MenuList,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
export default chakraComponents;
//# sourceMappingURL=index.js.map